import { useEffect, useState } from "react"
import { Action, PanelLoader } from "../../../../features/ui"
import { BookmarkButton } from "../../../../features/bookmarks"
import { PendingPaymentList } from "./pendingPaymentList"
import { PurchaseOrder, Supplier, useSupplierLoaders } from "../../../purchases"
import { RoutePath, useRoutesHooks } from "../../../../features/routes"
import { useTicketLoaders } from "../../loaders/ticketLoaders"
import { Expense, Ticket } from "../../state/types"
import { dedupe } from "../../../../utils/listUtils"

export const PendingPaymentListLoader = () => {
    const [suppliers, setSuppliers] = useState<Supplier[]>([])
    const [tickets, setTickets] = useState<Ticket[]>([])
    const [parents, setParents] = useState<(PurchaseOrder | Expense)[]>([])
    const [ready, setReady] = useState(false)

    const { getRoutePath } = useRoutesHooks()

    const ticketLoaders = useTicketLoaders()
    const supplierLoaders = useSupplierLoaders()

    const populate = async () => {
        const { loadAllTickets, loadParents } = ticketLoaders()
        const loadedTickets = await loadAllTickets()
        setTickets(loadedTickets)
        const ticketIds = dedupe(loadedTickets.map(ticket => ticket.id))
        const parents = await loadParents(ticketIds)
        setParents(parents)
        const { loadAllSuppliers } = supplierLoaders()
        const loadedSuppliers = await loadAllSuppliers()
        setSuppliers(loadedSuppliers)
    }

    useEffect(() => {
        populate().then(() => setReady(true))
    }, [])

    const headerActions: Action[] = [
        { label: 'Órdenes de Pago', kind: 'tertiary', href: getRoutePath(RoutePath.PAYMENT_ORDERS) }
    ]

    return (
        <PanelLoader
            title="Pagos Pendientes"
            actions={headerActions}
            ready={ready}
            wide
            titleRight={<BookmarkButton routePath={RoutePath.PENDING_PAYMENTS} />}
        >
            <PendingPaymentList
                suppliers={suppliers}
                tickets={tickets}
                parents={parents}
            />
        </PanelLoader>
    )
}
